const state = {
  openid: ""
};

const mutations = {
  SET_OPENID(state, b) {
    state.openid = b;
  }
};

const actions = {};

export default {
  namespaced: true, //用于在全局引用此文里的方法时标识这一个的文件名
  state,
  mutations,
  actions
};
